///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/point-promotions.filter.ts"/>
///<reference path="../collections/report-users.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class CSEEmployeesWithCategoriesDataTemplate extends DataTemplateBase implements IDataTemplate {
        protected employeeCategories: CSEEmployeeCategoriesCollection;
        protected employees: CSEEmployeesCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;
        public totalParentSelectedMessage: string;

        get collection() {
            return this.employeeCategories;
        }

        get totalSelectedCount(): number {
            return this.employees.value.length;
        }

        get totalParentSelectedCount(): number {
            return this.employeeCategories.value.length;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.employeeCategories = new CSEEmployeeCategoriesCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                smartMoverHidden: () => this.smartMoverHidden
            });
            this.employees = new CSEEmployeesCollection(this.model[properties[1]], [], {
                criteria: options.criteria,
                smartMoverHidden: () => this.smartMoverHidden
            });

            this.employees.setParentCollection(this.employeeCategories, EmployeeToCategoriesStrategy);

            this.filters = [
                new ActiveInactiveFilter({hideInactiveLabel: 'LABEL_HIDE_INACTIVE_EMPLOYEES'}, this)
            ];
            this.employees.addFilters(...this.filters as IInteractiveFilter[]);

            this.title = 'LABEL_EMPLOYEE_CATEGORY_EMPLOYEE';
            this.allSelectedLabel = 'LABEL_ALL_EMPLOYEES_UPPER';
            this.totalSelectedMessage = 'LABEL_TOTAL_EMPLOYEES_SELECTED';
            this.totalParentSelectedMessage = 'LABEL_TOTAL_EMPLOYEE_CATEGORIES_SELECTED';
        }

        setWatchers(scope: angular.IScope) {
            super.setWatchers(scope);

            this.employees.setWatchers(scope);
        }

        onHideToggle(hidden: boolean): void {
            this.smartMoverHidden = hidden;
        }
    }
}
